const home = [{
    path: "index",
    name: "index",
    component: () =>
      import("@/views/businessView/index/index.vue"),
    meta: {
      title: "后台管理-首页",
    },
  }, {
    path: "account",
    name: "account",
    component: () =>
      import("@/views/businessView/account/account.vue"),
    meta: {
      title: "后台管理-账户信息",
    },
  },
 {
    path: "storeConfig",
    name: "storeConfig",
    component: () =>
      import("@/views/businessView/shopManage/storeConfig.vue"),
    meta: {
      title: "后台管理-店铺交易配置",
    },
  },
  {
    path: "goodsOpeation",
    name: "goodsOpeation",
    component: () =>
      import("@/views/businessView/commodity/goodsOpeation.vue"),
    meta: {
      title: "后台管理-商品中心",
    },
  },
  {
    path: "commodity",
    name: "commodity",
    component: () =>
      import("@/views/businessView/commodity/commodity.vue"),
    meta: {
      title: "后台管理-商品中心",
    },
  },
  {
    path: "activityGoods",
    name: "activityGoods",
    component: () =>
      import("@/views/businessView/commodity/activityGoods.vue"),
    meta: {
      title: "后台管理-活动商品",
    },
  },
  {
    path: "Content",
    name: "Content",
    component: () => import("@/views/businessView/Content/ContentManagement.vue"),
    meta: {
      title: "内容管理-素材中心",
    },
  },
  {
    path: "FunctionSettings",
    name: "FunctionSettings",
    component: () => import("@/views/businessView/FunctionSettings/NonDeliverable.vue"),
    meta: {
      title: "功能设置-不可发货",
    },
  },
  {
    path: "orders",
    name: "orders",
    component: () =>
      import("@/views/businessView/orders/orders.vue"),
    meta: {
      title: "后台管理-订单管理",
    },
  },
  {
    path: "orderdetails",
    name: "orderdetails",
    component: () => import("@/views/businessView/orders/component/orderdetails.vue"),
    meta: {
      title: "后台管理-订单详情",
    },
  },
  {

    path: "returnedPurchase",
    name: "returnedPurchase",
    component: () => import("@/views/businessView/orders/ReturnedPurchase.vue"),
    meta: {
      title: "后台管理-退货列表",
    },
  },
  {
    path: "refundList",
    name: "refundList",
    component: () => import("@/views/businessView/orders/RefundList.vue"),
    meta: {
      title: "后台管理-退款列表",
    },
  },
  {
    path: "logisticsOrder",
    name: "logisticsOrder",
    component: () =>
      import("@/views/businessView/logisticsOrder/logisticsOrder.vue"),
    meta: {
      title: "后台管理-物流订单",
    },
  },
  {
    path: "depositOrder",
    name: "depositOrder",
    component: () =>
      import("@/views/businessView/depositOrder/depositOrder.vue"),
    meta: {
      title: "后台管理-店铺资金订单",
    },
  },


  /*    {
         path: "refund",
         name: "refund",
         component: () =>
             import ("@/views/businessView/refund/refund.vue"),
         meta: {
             title: "后台管理-退款退货",
         },
     }, */

  {
    path: "retunPudDetail",
    name: "retunPudDetail",
    component: () =>
      import("@/views/businessView/orders/component/retunPudDetail.vue"),
    meta: {
      title: "订单管理-退货详情",
    },
  },
  {
    path: "refunDetail",
    name: "refunDetail",
    component: () =>
      import("@/views/businessView/orders/component/refunDetail.vue"),
    meta: {
      title: "订单管理-退款详情",
    },
  },
  {
    path: "refundList",
    name: "refundList",
    component: () => import("@/views/businessView/orders/RefundList.vue"),
    meta: {
      title: "后台管理-退款列表",
    },
  },

  {
    path: "withdrawal",
    name: "withdrawal",
    component: () =>
      import("@/views/businessView/withdrawal/withdrawal.vue"),
    meta: {
      title: "后台管理-提现管理",
    },
  },
  {
    path: "coupon",
    name: "coupon",
    component: () =>
      import("@/views/businessView/coupon/coupon.vue"),
    meta: {
      title: "后台管理-券列表",
    },
  },
  {
    path: "release",
    name: "release",
    component: () =>
      import("@/views/businessView/coupon/release.vue"),
    meta: {
      title: "后台管理-发券",
    },
  },
  {
    path: "activity",
    name: "activity",
    component: () =>
      import("@/views/businessView/activity/activity.vue"),
    meta: {
      title: "后台管理-活动运营",
    },
  },
  {
    path: "message",
    name: "message",
    component: () =>
      import("@/views/businessView/message/message.vue"),
    meta: {
      title: "消息中心",
    },
  },
  {
    path: "poster",
    name: "poster",
    component: () =>
      import("@/views/businessView/poster/poster.vue"),
    meta: {
      title: "海报邮寄",
    },
  },
  {
    path: "viewData",
    name: "viewData",
    component: () =>
      import("@/views/businessView/viewData/viewData.vue"),
    meta: {
      title: "数据统计",
    },
  },
  {
    path: "marketingManagement",
    name: "marketingManagement",
    component: () =>
      import("@/views/businessView/brand/MarketingManagement/MarketingManagement.vue"),
    meta: {
      title: "经销商管理",
    },
  },
  {
    path: "productManagement",
    name: "productManagement",
    component: () =>
      import("@/views/businessView/brand/ProductManagement/ProductManagement.vue"),
    meta: {
      title: "产品管理",
    },
  },
  {
    path: "propertyManagement",
    name: "propertyManagement",
    component: () =>
      import("@/views/businessView/brand/PropertyManagement/PropertyManagement.vue"),
    meta: {
      title: "产权管理",
    },
  },
  {
    path: "installSale",
    name: "installSale",
    component: () =>
      import("@/views/businessView/brand/InstallSale/InstallSale.vue"),
    meta: {
      title: "产权管理",
    },
  },
  {
    path: "violation",
    name: "violation",
    component: () =>
      import("@/views/businessView/brand/Violation/Violation.vue"),
    meta: {
      title: "违规监控",
    },
  },
  {
    path: "infringement",
    name: "infringement",
    component: () =>
      import("@/views/businessView/brand/Infringement/Infringement.vue"),
    meta: {
      title: "侵权监控",
    },
  },
  {
    path: "brandCrisis",
    name: "brandCrisis",
    component: () =>
      import("@/views/businessView/brand/BrandCrisis/BrandCrisis.vue"),
    meta: {
      title: "品牌危机",
    },
  },
  {
    path: "internalCrisis",
    name: "internalCrisis",
    component: () =>
      import("@/views/businessView/brand/InternalCrisis/InternalCrisis.vue"),
    meta: {
      title: "内部危机",
    },
  },

  {
    path: "priceWarn",
    name: "priceWarn",
    component: () =>
      import("@/views/businessView/priceProtection/PriceWarn/PriceWarn.vue"),
    meta: {
      title: "价格预警",
    },
  },

  {
    path: "quickPriceWarn",
    name: "priceWarn",
    component: () =>
      import("@/views/businessView/priceProtection/QuickPriceWarn/QuickPriceWarn.vue"),
    meta: {
      title: "快速价格预警",
    },
  },

  {
    path: "violationWarn",
    name: "violationWarn",
    component: () =>
      import("@/views/businessView/priceProtection/ViolationWarn/ViolationWarn.vue"),
    meta: {
      title: "违规预警",
    },
  },

  {
    path: "marketWarn",
    name: "marketWarn",
    component: () =>
      import("@/views/businessView/priceProtection/MarketWarn/MarketWarn.vue"),
    meta: {
      title: "市场预警",
    },
  },
  {
    path: "application",
    name: "application",
    component: () =>
      import("@/views/businessView/application/Application.vue"),
    meta: {
      title: "营销玩法",
    },
  },
  {
    path: "marketing",
    name: "marketing",
    component: () =>
      import("@/views/businessView/application/Marketing.vue"),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "orderCashback",
    name: "orderCashback",
    component: () =>
      import("@/views/businessView/application/OrderCashback.vue"),
    meta: {
      title: "应用中心-订单返现",
    },
  },
  {
    path: "solitaire",
    name: "solitaire",
    component: () =>
      import("@/views/businessView/application/Solitaire.vue"),
    meta: {
      title: "应用中心-接龙购",
    },
  },
  {
    path: "quickwarn",
    name: "quickwarn",
    component: () =>
      import("@/views/businessView/brand/QuickWarn/QuickWarn.vue"),
    meta: {
      title: "快速预警",
    },
  },
  {
    path: "performanceData",
    name: "performanceData",
    component: () =>
      import("@/views/businessView/commodity/PerformanceData.vue"),
    meta: {
      title: "效果数据",
    },
  },
  {
    path: "shopManage",
    name: "shopManage",
    component: () =>
      import("@/views/businessView/shopManage/ShopManage.vue"),
    meta: {
      title: "店铺管理",
    },
  },
  {
    path: "fixShopList",
    name: "fixShopList",
    component: () =>
      import("@/views/businessView/shopManage/fixShopList.vue"),
    meta: {
      title: "店铺装修",
    },
  },
  {
    path: "fixShop",
    name: "fixShop",
    component: () =>
      import("@/views/businessView/shopManage/fixShop.vue"),
    meta: {
      title: "店铺装修",
    },
  },
  {
    path: "shopInfoManage",
    name: "shopManage",
    component: () =>
      import("@/views/businessView/shopManage/ShopInfoManage.vue"),
    meta: {
      title: "店铺管理",
    },
  },
  {
    path: "shopApply/:type",
    name: "shopApply",
    component: () =>
      import("@/views/businessView/shopManage/ShopApply.vue"),
    meta: {
      title: "店铺申请",
    },
  },
  {
    path: "shopApply/:type/:id",
    name: "shopApply",
    component: () =>
      import("@/views/businessView/shopManage/ShopApply.vue"),
    meta: {
      title: "店铺申请",
    },
  },
  {
    path: "monitor",
    name: "monitor",
    component: () =>
      import("@/views/businessView/monitor/Monitor.vue"),
    meta: {
      title: "价格检测",
    },
  },
  {
    path: "productMonitor/:type/:id",
    name: "productMonitor",
    component: () =>
      import("@/views/businessView/monitor/ProductMonitor.vue"),
    meta: {
      title: "产品检测",
    },
  },
  {
    path: "productMonitorDetail/:type/:id",
    name: "productMonitorDetail",
    component: () =>
      import("@/views/businessView/monitor/ProductMonitorDetail.vue"),
    meta: {
      title: "产品检测",
    },
  },
  {
    path: "productMonitorDetail/:type/:pid/:id",
    name: "productMonitorDetail",
    component: () =>
      import("@/views/businessView/monitor/ProductMonitorDetail.vue"),
    meta: {
      title: "产品检测",
    },
  },

  {
    path: "erweimaactive",
    name: "erweimaactive",
    component: () =>
      import("@/views/businessView/erweima/erweimaActive.vue"),
    meta: {
      title: "活动发布",
    },
  },


  {
    path: "activemanage",
    name: "activemanage",
    component: () =>
      import("@/views/businessView/erweima/activemanage.vue"),
    meta: {
      title: "激活管理",
    },
  },

  {
    path: "erweimaorder",
    name: "erweimaorder",
    component: () =>
      import("@/views/businessView/erweima/erweimaorder.vue"),
    meta: {
      title: "订单管理",
    },
  },

  {
    path: "messagetip",
    name: "messagetip",
    component: () =>
      import("@/views/businessView/erweima/messagetip.vue"),
    meta: {
      title: "消息管理",
    },
  },
  {
    path: "toollist",
    name: "toollist",
    component: () =>
      import("@/views/businessView/erweima/toolList.vue"),
    meta: {
      title: "购买次数",
    },
  },

  {
    path: "peiceAlert",
    name: "peiceAlert",
    component: () =>
      import("@/views/businessView/monitor/peiceAlert.vue"),
    meta: {
      title: "价格预警",
    },
  },

  {
    path: "bill",
    name: "bill",
    component: () =>
      import("@/views/businessView/bill/Bill.vue"),
    meta: {
      title: "账单中心",
    },
  },
  {
    path: "cardManage",
    name: "cardManage",
    component: () =>
      import("@/views/businessView/cardManage/CardManage.vue"),
    meta: {
      title: "福利卡",
    },
  },

  {
    path: "detection",
    name: "detection",
    component: () =>
      import("@/views/businessView/bill/Detection.vue"),
    meta: {
      title: "检测套餐",
    },
  },
  {
    path: "Address",
    name: "Address",
    component: () =>
      import("@/views/businessView/Address/index.vue"),
    meta: {
      title: "地址列表",
    },
  },
  {
    path: "DataAnalysis",
    name: "DataAnalysis",
    component: () =>
      import("@/views/businessView/DataAnalysis/Dataanalysis.vue"),
    meta: {
      title: "数据分析",
    },
  },
  {
    path: "MerchanDising",
    name: "MerchanDising",
    component: () =>
      import("@/views/businessView/DataAnalysis/Merchandising.vue"),
    meta: {
      title: "商品销售",
    },
  },
  {
    path: "CompanyProportion",
    name: "CompanyProportion",
    component: () =>
      import("@/views/businessView/DataAnalysis/Companyproportion.vue"),
    meta: {
      title: "物流公司占比",
    },
  },
  {
    path: "ShippingStatistics",
    name: "ShippingStatistics",
    component: () =>
      import("@/views/businessView/DataAnalysis/Shippingstatistics.vue"),
    meta: {
      title: "发货统计",
    },
  },
  {
    path: "refunDetail",
    name: "refunDetail",
    component: () =>
      import("@/views/businessView/orders/component/refunDetail.vue"),
    meta: {
      title: "订单管理-退款详情",
    },
  },
  {
    path: "qualityControl",
    name: "qualityControl",
    component: () =>
      import("@/views/businessView/commodity/goodsQualityControl.vue"),
    meta: {
      title: "后台管理-品控商品一览",
    },
  },
  {
    path: "qualityDetails",
    name: "qualityDetails",
    component: () =>
      import("@/views/businessView/commodity/component/qualityDetails.vue"),
    meta: {
      title: "后台管理-品控商品一览",
    },
  },
  {
    path: "optimization",
    name: "optimization",
    component: () =>
      import("@/views/businessView/commodity/component/optimization.vue"),
    meta: {
      title: "后台管理-品控商品一览",
    },
  },
  {
    path: "trade",
    name: "trade",
    component: () =>
      import("@/views/businessView/commodity/trade.vue"),
    meta: {
      title: "后台管理-交易量统计",
    },
  },
  {
    path: "pageView",
    name: "pageView",
    component: () =>
      import("@/views/businessView/commodity/pageView.vue"),
    meta: {
      title: "后台管理-访问量统计",
    },
  },
  {
      path: "tickets-data",
      name: "TicketsData",
      component: () =>
          import ("@/views/businessView/dashboard/tickets-data.vue"),
      meta: {
          title: "数据统计-门票数据",
      },
  },
  {
      path: "baby-paradise",
      name: "BabyParadise",
      component: () =>
          import ("@/views/businessView/orders/baby-paradise.vue"),
      meta: {
          title: "订单管理-亲子项目订单",
      },
  },
  {
      path: "baby-paradise-details",
      name: "BabyParadiseDetails",
      component: () =>
          import ("@/views/businessView/orders/component/babyParadiseDetails.vue"),
      meta: {
          title: "订单管理-亲子项目订单详情",
      },
  },
  {
      path: "auditManage",
      name: "AuditManage",
      component: () =>
          import ("@/views/businessView/auditManage"),
      meta: {
          title: "审核管理",
      },
  },
  {
      path: "baby-ticket-manage",
      name: "BabyTicketManage",
      component: () =>
          import ("@/views/businessView/auditManage/babyTicketManage.vue"),
      meta: {
          title: "审核管理-亲子票务管理",
      },
  },
  {
      path: "baby-ticket-form",
      name: "BabyTicketForm",
      component: () =>
          import ("@/views/businessView/auditManage/component/babyTicketForm.vue"),
      meta: {
          title: "审核管理-亲子票务管理-表单",
      },
  },
  {
      path: "baby-ticket-details",
      name: "BabyTicketDetails",
      component: () =>
          import ("@/views/businessView/auditManage/component/babyTicketDetails.vue"),
      meta: {
          title: "审核管理-亲子票务管理-亲子票务详情",
      },
  },
  {
      path: "baby-ticket-appraise",
      name: "BabyTicketAppraise",
      component: () =>
          import ("@/views/businessView/auditManage/component/babyTicketAppraise.vue"),
      meta: {
          title: "审核管理-亲子票务管理-评价列表",
      },
  },
  {
      path: "baby-ticket-appraise-details",
      name: "BabyTicketAppraiseDetails",
      component: () =>
          import ("@/views/businessView/auditManage/component/babyTicketAppraiseDetails.vue"),
      meta: {
          title: "审核管理-亲子票务管理-评价详情",
      },
  },
  {
      path: "feature",
      name: "Feature",
      component: () =>
          import ("@/views/businessView/feature"),
      meta: {
          title: "功能设置",
      },
  },
  {
      path: "feature-calendar",
      name: "FeatureCalendar",
      component: () =>
          import ("@/views/businessView/feature/calendar.vue"),
      meta: {
          title: "功能设置-预约日历",
      },
  },
  {
      path: "writeOffManage",
      name: "WriteOffManage",
      component: () => 
          import ("@/views/businessView/writeOff"),
      meta: {
          title: "核销管理"
      }
  },
  {
      path: "i-want-write",
      name: "IWantWriteOff",
      component: () => 
          import ("@/views/businessView/writeOff/iWant.vue"),
      meta: {
          title: "我要核销"
      }
  },
  {
      path: "write-record",
      name: "WriteOff",
      component: () => 
          import ("@/views/businessView/writeOff/record.vue"),
      meta: {
          title: "核销记录"
      }
  },


  //权限
  {
    path: "role",
    name: "role",
    component: () =>
      import("@/views/controlManage/roleManage.vue"),
  },
  {
    path: "addRole",
    name: "addRole",
    component: () =>
      import("@/views/controlManage/roleCom/addRole.vue"),
  },
  {
    path: "accountMember",
    name: "accountMember",
    component: () =>
      import("@/views/controlManage/accountIndex.vue"),
  },
  {
    path: "shortMessageHistory",
    name: "shortMessageHistory",
    component: () =>
      import("@/views/businessView/message/shortMessageHistory.vue"),
  },




















];
export default home;